/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";
import {firebaseChatDB} from "@/main.js";
import User from "@/models/User.js";
import Chat from "@/models/Chat.js";
import ChatMessage from "@/models/ChatMessage.js";

export default {
	setChatSearchQuery({commit}, query) {
		commit("SET_CHAT_SEARCH_QUERY", query);
	},
	updateAboutChat({commit, rootState}, value) {
		commit("UPDATE_ABOUT_CHAT", {
			rootState,
			value,
		});
	},
	updateStatusChat({commit, rootState}, value) {
		commit("UPDATE_STATUS_CHAT", {
			rootState,
			value,
		});
	},

	sendChatMessage({dispatch}, {receiver, text, chatKey, is_group}) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();
				const chatMessage = new ChatMessage({
					sender: userInfo.id,
					receiver,
					text,
					is_group,
				});

				const localTimeStamp = new Date().getTime().toString();
				await firebaseChatDB
					.ref(`chat/${userInfo.company_id}/chats/${chatKey}/messages/${localTimeStamp}`)
					.set(chatMessage);

				chatMessage.receiver.forEach((rc) => {
					dispatch("sendFCMNotification", {
						title: `${userInfo.name} ${userInfo.lastname}`,
						body: text,
						chat_room: chatKey,
						is_group_chat: is_group,
						contactId: rc,
					});
				});
			} catch (error) {
				reject(error);
				throw new Error(error);
			}
		});
	},
	async startChatRoom({dispatch}, {receiver, text}) {
		return new Promise(async (resolve, reject) => {
			const user = new User();

			try {
				const userInfo = await user.getUser();
				const chatMessage = new ChatMessage({
					sender: userInfo.id,
					receiver,
					text,
				});

				const chat = new Chat({
					members: [userInfo.id].concat(receiver),
				});
				const localTimeStamp = new Date().getTime().toString();
				chat.messages[localTimeStamp] = chatMessage;
				const chatReference = await firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/`);
				const chatKey = await chatReference.push().key;

				await firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${chatKey}`).set(chat);

				chat.members.forEach(async (member, key, data) => {
					await firebaseChatDB
						.ref(`chat/${userInfo.company_id}/users/${member}/dm/${chatKey}`)
						.set(data.filter((d) => d !== member)[0]);
				});

				dispatch("sendFCMNotification", {
					title: `${userInfo.name} ${userInfo.lastname}`,
					body: text,
					chat_room: chatKey,
					is_group_chat: false,
					contactId: receiver[0],
				});
				resolve(chatKey);
			} catch (error) {
				reject(error);
			}
		});
	},
	async startGroupChatRoom({dispatch}, {receiver, text, name}) {
		return new Promise(async (resolve, reject) => {
			const user = new User();

			try {
				const userInfo = await user.getUser();
				const chatMessage = new ChatMessage({
					sender: userInfo.id,
					receiver,
					text,
					is_group: true,
				});

				const chat = new Chat({
					members: [userInfo.id].concat(receiver),
					admin: userInfo.id,
					name,
				});

				const localTimeStamp = new Date().getTime().toString();
				chat.messages[localTimeStamp] = chatMessage;

				const chatReference = await firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/`);
				const chatKey = await chatReference.push().key;

				await firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${chatKey}`).set(chat);

				chat.members.forEach(async (member) => {
					await firebaseChatDB
						.ref(`chat/${userInfo.company_id}/users/${member}/group/${chatKey}`)
						.set(chat.name);
					dispatch("sendFCMNotification", {
						title: chat.name,
						body: text,
						chat_room: chatKey,
						is_group_chat: true,
						contactId: member,
					});
				});

				resolve(chatKey);
			} catch (error) {
				reject(error);
			}
		});
	},
	async updateGroupChatRoom({dispatch}, payload) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();

				payload.members.forEach(async (member) => {
					await firebaseChatDB
						.ref(`chat/${userInfo.company_id}/users/${member}/group/${payload.chatKey}`)
						.set(payload.name);
				});

				// Update Members
				const chatsRef = firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${payload.chatKey}`);
				chatsRef.once("value", (snapshot) => {
					snapshot.ref.update({...snapshot.val(), name: payload.name, members: payload.members});
				});
				resolve({message: "ok"});
			} catch (error) {
				reject(error);
			}
		});
	},
	sendFCMNotification({state}, payload) {
		const foundFcmToken = state.contactsFcm.find((contact) => contact.contactId === payload.contactId);
		const data = {
			to: foundFcmToken ? foundFcmToken.fcm_token : "",
			data: {
				title: payload.title,
				body: payload.body,
				chat_room: payload.chat_room,
				is_group_chat: payload.is_group_chat ? "GROUP_CHAT" : "SINGLE_CHAT", // SINGLE_CHAT    GROUP_CHAT payload.is_group_chat,
			},
		};
		fetch(`https://fcm.googleapis.com/fcm/send`, {
			method: "POST", // or 'PUT'
			body: JSON.stringify(data), // data can be `string` or {object}!
			headers: {
				Authorization: `key=${process.env.VUE_APP_FIREBASE_MESSAGING_TOKEN}`,
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				return response.json();
			})
			.then((response) => {})
			.catch((err) => console.error(err));
	},
	// Get contacts from server. Also change in store
	fetchContacts({commit, dispatch}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				id: (data && data.id) || [],
				fields: [
					"id",
					"name",
					"lastname",
					"username",
					"identification",
					"email",
					"img_url",
					"role_name",
					"positionrecord_id",
					"company_id",
				],
				order_by: "name",
				sort: "ASC",
				page: null,
				quantity: null,
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					if (payload.id.length <= 0) {
						commit("UPDATE_CONTACTS", res.data.records);
					}
					resolve(res.data.records);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	// Get chats from server. Also change in store
	fetchChats({commit}) {
		return new Promise((resolve, reject) => {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			firebaseChatDB.ref(`chat/${userInfo.datarutas_company_id}`).on("value", (snapshot) => {
				const {chats, users} = snapshot.val();
				commit("UPDATE_CHAT_CONTACTS", users);
				commit("UPDATE_FCM_TOKEN_CONTACTS", users);
				commit("UPDATE_CHATS", chats);
				commit("SET_TOTAL_UNSEEN");
				resolve(users);
			});
		});
	},
	registerUsers({commit}, {fcm_token, dm, groups}) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			const userInfo = await user.getUser();
			await firebaseChatDB.ref(`chat/${userInfo.company_id}/users/${userInfo.id}/fcm_token`).set(fcm_token);
		});
	},
	getFcmToken({commit}, contactId) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();
				const fcmToken = await firebaseChatDB.ref(`chat/${userInfo.company_id}/users/${contactId}/fcm_token`);
				resolve(fcmToken);
			} catch (error) {
				reject(error);
			}
		});
	},
	markSeenAllMessages(state, payload) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();

				// Obtenemos el sender
				const sender = payload.members.find((m) => m !== userInfo.id);

				// Consultar toodos los mensajes del chat room donde el sender
				// no sea el usuario en sesion
				const chatsRef = firebaseChatDB
					.ref(`chat/${userInfo.company_id}/chats/${payload.key}/messages`)
					.orderByChild("sender")
					.equalTo(sender);

				chatsRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						childSnapshot.ref.update({...childSnapshot.val(), is_seen: true});
					});
				});
			} catch (error) {
				reject(error);
			}
		});
	},
	markSeenAllGroupMessages(state, payload) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();
				// Consultar toodos los mensajes del chat room
				const chatsRef = firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${payload.key}/messages`);
				chatsRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						const valUp = childSnapshot.val();
						if (+valUp.sender !== +userInfo.id) {
							valUp.is_seen[userInfo.id] = true;
							childSnapshot.ref.update(valUp);
						}
					});
				});
			} catch (error) {
				reject(error);
			}
		});
	},
	removeMemberFromGroup(state, payload) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();
				await firebaseChatDB
					.ref(`chat/${userInfo.company_id}/users/${payload.memberId}/group/${payload.chatKey}`)
					.set(null);

				const chatsRef = firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${payload.chatKey}`);
				chatsRef.once("value", (snapshot) => {
					const filterMembers = snapshot.val().members.filter((m) => m !== payload.memberId);
					snapshot.ref.update({...snapshot.val(), members: filterMembers});
				});
				resolve({message: "ok"});
			} catch (error) {
				reject(error);
			}
		});
	},
	deleteChatRoom({state}, payload) {
		return new Promise(async (resolve, reject) => {
			const user = new User();
			try {
				const userInfo = await user.getUser();
				await firebaseChatDB.ref(`chat/${userInfo.company_id}/chats/${payload.key}`).set(null);
				payload.members.forEach(async (member) => {
					await firebaseChatDB.ref(`chat/${userInfo.company_id}/users/${member}/dm/${payload.key}`).set(null);
				});
				resolve(payload);
			} catch (error) {
				reject(error);
			}
		});
	},
};
